import type { HTMLAttributes } from 'react';
import { getBrand } from './resolve';
import { cn } from '@/lib/utils';

export function BrandLogo({
  className,
  size = 32,
  alt,
  decorative = false,
  ...rest
}: {
  className?: string;
  size?: number;
  alt?: string;
  decorative?: boolean;
} & Omit<HTMLAttributes<HTMLImageElement>, 'src' | 'alt' | 'width' | 'height'>) {
  const brand = getBrand();
  return (
    <img
      src={brand.assets.logo}
      alt={decorative ? '' : (alt ?? brand.name)}
      className={cn('rounded-md', className)}
      width={size}
      height={size}
      {...rest}
    />
  );
}
